import { getUnexpiredToken } from "@/utils/utils";
import { SignedInSessionResource } from "@clerk/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const gitStatusSlice = createSlice({
  name: "gitStatus",
  initialState: {
    gitStatus: null,
    status: "idle",
    requestInProgress: false,
    error: null,
  },
  reducers: {
    setRequestInProgress: (state, action) => {
      state.requestInProgress = action.payload;
    },
    resetGithubState: (state) => {
      state.gitStatus = null;
      state.status = "idle";
      state.requestInProgress = false;
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchGitStatus.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchGitStatus.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }

        state.status = "succeeded";
        state.gitStatus = action.payload;
        state.requestInProgress = false;
      })
      .addCase(fetchGitStatus.rejected, (state, action) => {
        state.status = "failed";
        // @ts-expect-error TS2322
        state.error = action.error.message;
        state.requestInProgress = false;
      });
  },
});

interface FetchGitStatusArgs {
  canvasId: string;
  session: SignedInSessionResource;
}

export const fetchGitStatus = createAsyncThunk(
  "gitStatus/fetch",
  async (data: FetchGitStatusArgs, thunkAPI: any) => {
    const { canvasId, session } = data;

    const token = await getUnexpiredToken(session);

    if (!canvasId || !token) {
      return null;
    }

    if (thunkAPI.getState().gitStatus.requestInProgress) {
      return null;
    }

    thunkAPI.dispatch(gitStatusSlice.actions.setRequestInProgress(true));

    const res = await axios.post(
      `${
        import.meta.env.VITE_BACKEND_BASE_URL
      }/canvases/${canvasId}/git/gitStatus`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  }
);

// Action creators are generated for each case reducer function
export const { resetGithubState } = gitStatusSlice.actions;

export default gitStatusSlice.reducer;
